import { X } from 'lucide-react';
import { useState } from 'react';

import { useActiveHeadline } from '@/api/hooks/useAdminHeadlines';

export default function HeadlineBanner() {
  const { data: headline, isLoading } = useActiveHeadline();
  const [dismissed, setDismissed] = useState(false);

  if (isLoading || !headline || dismissed) return null;

  const Wrapper = headline.link_url ? 'a' : 'span';

  return (
    <div
      className="relative w-full flex items-center justify-center px-4 py-1.5 text-xs font-medium text-center"
      style={{
        backgroundColor: headline.background_color || '#8B5CF6',
        color: headline.text_color || '#FFFFFF',
      }}
    >
      <Wrapper
        {...(headline.link_url
          ? {
              href: headline.link_url,
              target: '_blank',
              rel: 'noopener noreferrer',
              className: 'hover:underline hover:opacity-90 transition-opacity',
            }
          : { className: '' })}
      >
        {headline.text}
        {headline.link_text && headline.link_url && (
          <span className="ml-1 font-bold underline underline-offset-2">
            {headline.link_text}
          </span>
        )}
      </Wrapper>

      <button
        onClick={() => setDismissed(true)}
        className="absolute right-3 top-1/2 -translate-y-1/2 opacity-70 hover:opacity-100 transition-opacity"
        aria-label="Fechar headline"
        style={{ color: headline.text_color || '#FFFFFF' }}
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
